import React, { useEffect } from "react"
import { Button } from "../../../components/ui/button"
import { Bell } from "lucide-react"
import { SidebarTrigger } from "../../../components/ui/sidebar"
import {
    Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,
    BreadcrumbPage, BreadcrumbSeparator,
} from "../../../components/ui/breadcrumb"
import { useUIContext } from "../../../Contexts/UIProvider"

const TopNavbar = (props: any) => {
    const { setIsInvitation, routeDto } = useUIContext();

    return (
        <div className="h-16 bg-sidebar flex items-center justify-between px-6 sticky top-0 z-10">
            <div className="flex items-center gap-8 text-sidebar-foreground">
                <SidebarTrigger />
                <Breadcrumb>
                    <BreadcrumbList>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbLink className="text-sidebar-foreground hover:text-sidebar-foreground/70 text-base" href="/app/home">Home</BreadcrumbLink>
                        </BreadcrumbItem>
                        {routeDto?.navId && routeDto?.navId !== 'home' && (
                            <>
                                <BreadcrumbSeparator />
                                <BreadcrumbItem>
                                    <BreadcrumbPage className="text-sidebar-foreground/70 hover:text-sidebar-foreground text-base">{routeDto?.navItem}</BreadcrumbPage>
                                </BreadcrumbItem>
                            </>
                        )}
                    </BreadcrumbList>
                </Breadcrumb>
            </div>

            <div className="flex items-center gap-16">
                <Button
                    variant="ghost"
                    className="relative hover:bg-gray-600 text-gray-200 p-2 rounded-full"
                    onClick={() => setIsInvitation(true)}
                >
                    <Bell className="h-5 w-5" />
                    <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                </Button>
            </div>
        </div>

    )
}

export default TopNavbar;